import React from 'react';
import { Box, Typography } from '@mui/material';
import appDemoGif from '../../assets/BODY BOOST FINAL.gif';

export default function HowItWorks() {
  return (
    <Box sx={{ width: '100%', pt: 4, pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'transparent' }}>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          color: '#333',
          mb: 1,
          textAlign: 'center',
          fontSize: '16px',
          fontFamily: "Inter, sans-serif"
        }}
      >
        Follow These Steps To Complete Task:
      </Typography>

      <Box sx={{ position: 'relative', mt: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            color: '#000', // Black color
            textAlign: 'center',
            zIndex: 1,
            position: 'relative',
            fontFamily: "General-Sans-bold, sans-serif",
            fontSize: '24px'
          }}
        >
          Install & feedback <span style={{ position: 'relative', display: 'inline-block' }}>
            this app
            <Box
              sx={{
                position: 'absolute',
                bottom: '4px',
                left: 0,
                right: 0,
                height: '8px',
                backgroundColor: '#FFD54F',
                zIndex: -1,
                opacity: 0.8,
                borderRadius: '2px'
              }}
            />
          </span>
        </Typography>
      </Box>

      {/* App Demo GIF */}
      <Box sx={{ width: '100%', maxWidth: '400px', mt: 4, mb: 2 }}>
        <Box
          sx={{
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          }}
          data-track="gif_container"
          data-name="landing_app_demo_gif"
        >
          <img
            src={appDemoGif}
            alt="App Demo"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
